import React from "react";
import Tabs from "../Tabs/Tabs";
import ModalHeader from "../ModalButtons/ModalHeader";
import ModalButtons from "../ModalButtons/ModalButtons";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import RuTaskBuilderErrors from "./RuTaskBuilderErrors";
import RuTaskBuilderWorkspace from "./RuTaskBuilderWorkspace";
import DateHelper from "../DateHelper/DateHelper";
import { format } from "date-fns";

class RuTaskBuilder extends React.Component {
  constructor(props) {
    super(props);
    let time_value = this.props.time_value
    if (this.props.time_period == "every_day_at") {
      
    }

    this.state = {
      active_tab: "general",
      loading: false,
      errors: this.props.errors ? this.props.errors : {},
      ru_task_queue_logs_data_table_path: this.props.ru_task_queue_logs_data_table_path,
      /* fields */
      rake_ru_task_name: this.props.rake_ru_task_name,
      time_period: this.props.time_period,
      time_value: this.props.time_period != "every_day_at" ? this.props.time_value : DateHelper.parseDateFromBackend(this.props.time_value),
      date_format: this.props.date_format,
      time_format: this.props.time_format,
      status: this.props.status || "disabled",
    };

    this.setActiveTab = this.setActiveTab.bind(this);
    this.onFieldChange = this.onFieldChange.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.prepParams = this.prepParams.bind(this);
  }

  render() {
    var buttons = [
      {
        name: I18n.t("cancel"),
        html_attributes: ['data-dismiss="modal"'],
      },
      {
        name: I18n.t("submit"),
        button_classes: ["primary"],
        onClick: this.onSubmit,
      },
    ];

    return (
      <div className="RuTaskBuilder">
        <Tabs
          tabs={this.tabs()}
          displayErrorMessage={
            RuTaskBuilderErrors.general(this.state.errors).length
              ? true
              : false
          }
        />
        <div className="panel panel-form">
          <ModalHeader helpText="room_types_users_guide" />
          <ModalButtons loading={this.state.loading} buttons={buttons} />
          <RuTaskBuilderWorkspace
            {...this.state}
            onFieldChange={this.onFieldChange}
            onChange={this.onChange}
          />
        </div>
        <LoadingSpinner show={this.state.loading} />
      </div>
    );
  }

  onSubmit() {
    var self = this;
    var params = this.prepParams();
    self.setState({ loading: true });
    setTimeout(function () {
      $.ajax({
        type: "PATCH",
        url: self.props.ru_task_update_path,
        data: params,
      }).done(function (data) {
        if (Object.keys(data.errors).length) {
          self.setState({
            errors: data.errors,
          });
          self.setState({ loading: false });
        } else {
          self.setState({ loading: false });
          window.parent.$(window.parent).trigger("taskSavedSuccessfully");
          if (parent && parent.refresh_data) {
            parent.refresh_data(I18n.t("task_saved_successfully"));
          }
          if (parent && parent.hide_modal) {
            parent.hide_modal();
          }
        }
      });
    }, 1000);
  }

  prepParams() {
    var time_value = this.state.time_value;
    if (this.state.time_period == "every_day_at") {
      time_value = format(
        this.state.time_value,
        DateHelper.rubyToDateFNS(this.state.time_format)
      );
    }

    return {
      task: {
        rake_ru_task_name: this.state.rake_ru_task_name,
        time_period: this.state.time_period,
        time_value: time_value,
        status: this.state.status,
      },
    };
  }

  tabs() {
    return (
      [
        {
          tabName: I18n.t("general"),
          targetName: "general",
          classes: this.state.active_tab === "general" ? "active" : null,
          changeHandler: this.setActiveTab,
          tabErrorCount: RuTaskBuilderErrors.general(this.state.errors)
            .length,
        },
        {
          tabName: I18n.t("ru_queue_logs"),
          targetName: "queue_logs",
          classes: this.state.active_tab === "queue_logs" ? "active" : null,
          changeHandler: this.setActiveTab,
        },
      ]
    );
  };

  setActiveTab(tab) {
    this.setState({
      active_tab: tab,
    });
  }

  onChange(name, event) {
    if (this.state.time_period == "every_day_at") {
      this.state[name] = event;
      this.setState(this.state);
    } else {
      this.state[name] = event.target.value;
      this.setState(this.state);
    }

  }

  onFieldChange(event) {
    if (event && event.target) {
      this.setState({
        [event.target.id]: event.target.value,
      });
    }
  }
}

export default RuTaskBuilder;
